// module.jsx



//////////////////
// WEBPACK FOOTER
// ./~/jest-cli/src/__tests__/test_root/module.jsx
// module id = 808
// module chunks = 0